import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { selectChannelById } from 'store/programs/selectors';
import { SearchProgram } from 'store/railsBuilder/reducer.types';
import { ReduxStore } from 'store/types';

import parseSearchParentalRating from 'services/data-manager/parsing/utils/parseSearchParentalRating';

const useSearchParentalRating = (program: SearchProgram | undefined) => {
    const channelId = program?.channel;

    const channel = useSelector((state: ReduxStore) =>
        selectChannelById(state, channelId),
    );

    return useMemo(
        () => parseSearchParentalRating(program, channel),
        [program, channel],
    );
};

export default useSearchParentalRating;
